import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full bg-brand-black my-auto px-4 z-50" }
const _hoisted_2 = { class: "flex flex-col space-y-8 my-auto py-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full space-y-1 px-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex text-brand-lime text-2xl font-medium" }, "Pineapple Rules"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-base" }, "The safety and comfort of our community is at the core of the Pineapple experience. We have a zero-tolerance policy towards violation of the following principles. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full space-y-1 px-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "No discrimination"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-base" }, "Pineapple is about inclusivity, acceptance and respect. Discriminatory and aggressive behaviour will result in removal from our platform and a ban from attending our events. ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full space-y-1 px-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Consent is key"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-base" }, "Consent is a fundamental principle of Pineapple. Take the time to talk about what you and your partner(s) expect from each other and always respect boundaries. No one owes you anything, so be prepared to hear, as well as say no. ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full space-y-1 px-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Be open to others"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-base" }, "We are all different. If someone is into something you don’t like or share, that doesn’t make it any less worthy of respect. Finding like-minded humans can take time and patience, so be open. ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full space-y-1 px-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Only real humans accepted"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray text-base" }, "Fake profiles, catfishing and other forms of falsified personas and identities will result in a permanent ban from the platform. Misuse of information will not be tolerated either, so only use photos and information you have permission to use. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "flex bg-brand-lime rounded-full w-full h-14 font-medium text-xl text-brand-black" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "my-auto pt-0.5" }, " I agree ")
  ])
], -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.forward && _ctx.forward(...args))),
                class: "flex flex-col space-y-2 w-full items-center"
              }, _hoisted_9)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}